import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { 
  Button, 
  Checkbox, 
  CheckboxGroup,
  Form,
  FormItem,
  Input,
  Drawer,
  Dialog,
  Divider,
  Loading, 
  Message 
} from 'element-ui'
import "@/styles/index.scss";
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Drawer)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$http = axios

new Vue({
  router, // 挂载 router
  store,  // 挂载 store
  render: h => h(App),
}).$mount('#app')

// 等待所有资源加载完成后再隐藏 loading
window.addEventListener('load', () => {
  const loading = document.getElementById('app-loading');
  if (loading) loading.style.display = 'none';
}); 